import { Component, Host, h, Element, Prop, State, Method, Listen } from '@stencil/core';

import Swiper, { Navigation, EffectCoverflow } from 'swiper';

import { jitsuClient } from '@jitsu/sdk-js'
// import posthog from 'posthog-js'
// if (!window.location.host.includes('127.0.0.1') && !window.location.host.includes('localhost')) {
//   posthog.init('phc_PFn3ipf7jR88MXFX73PMM6l7A0G5EeZf0llC0u5FVKv', { api_host: 'https://app.posthog.com', autocapture: false, capture_pageview: false})
// }

// //init
const jitsu = jitsuClient({
    key: "js.ku52f0vferwtf16hunn8p6.s4zhwpli8w7pwz9k0y1kc",
    tracking_host: "https://t.jitsu.com"
});

@Component({
  tag: 'as-reels',
  styleUrl: 'as-reels.css',
  shadow: true,
})
export class AsReels {

  @Element() el: HTMLElement;

  @Prop({ attribute: 'pid' }) playlistId: string;
  @Prop({ attribute: 'cid', mutable: true }) channelId?: string = null;
  @Prop() fsplaylist?: any;
  @Prop() env?: string = '';
  @Prop() mode?: string = 'default'; // default, autoplay
  @Prop() fullscreen?: boolean = true;
  @Prop({ mutable: true }) platform?: any = 'web'; 
  @Prop({ mutable: true }) selectedVid?: any = 0;
  @Prop({ mutable: true }) tk: boolean = true;
  @Prop({ mutable: true }) variant?: string = "title";
  @Prop() ch?: number = 400;
  @Prop() size?: string = 'default';
  @Prop({ mutable: true }) open?: boolean = false;
  @Prop() startindex?: number = 0;

  @State() playlist: any = null;
  @State() loading: boolean = true;
  @State() forcemute: boolean = false;
  @State() cslready: boolean = false;
  @State() curIndex?: number = 0;
  @State() rh?:number = 0;

  private showfootertitle: boolean = true;
  private showProductChip: boolean = false;
  private showProductCard: boolean = false;
  private items: any = [];
  private observer: IntersectionObserver;
  private swiper: any;
  private fullscreenPlayer: any = null;

  @Method()
  async enter(index = 0) {
    if(!this.open) {
      this.swiper.slideTo(index);
      this.open = true;
      this.startindex = index;
      if(index === 0) {
        const aplayers: any = this.el?.shadowRoot.querySelectorAll('.swiper-slide');
        this.fullscreenPlayer = aplayers[0]?.querySelector('as-player');
        this.fullscreenPlayer?.play();
        this.curIndex = 0;
      }
      // this.curIndex = index;
      setTimeout(() => { const anim: any = this.el.shadowRoot.querySelector('.swipeup-animation');
                anim.style.display='none'; }, 5000);
    }
  }

  @Method()
  async exit() {
    if(this.open) {
      this.open = false;
      this.closeReels();
      var uri = window.location.toString();
      if (uri.indexOf("#") > 0) {
          var clean_uri = uri.substring(0,
                          uri.indexOf("#"));
          window.history.replaceState({},
                  document.title, clean_uri);
      }
    }
  }

  @Listen('resize', { target: 'window', passive: true })
  async windowResize() {

    let rh = window.innerHeight - 40;

    if(window.innerWidth > 576) {
      this.swiper.params.effect = 'coverflow';
      this.swiper.params.coverflowEffect= {
        rotate: 0,
        stretch: 240,
        depth: 100,
        modifier: 1,
        scale: 0.8,
        slideShadows : true,
      };
      this.swiper.params.slidesPerView = 'auto';
      this.swiper.params.centeredSlides = true;
      this.swiper.changeDirection('horizontal', true);
    } else {
      rh = window.innerHeight;
      this.swiper.params.effect = 'slide';
      this.swiper.params.slidesPerView = 1;
      this.swiper.params.centeredSlides = false;
      this.swiper.changeDirection('vertical', true);
    }
    this.rh = (rh < 1024) ? rh : 1024;
    this.swiper.update();
  }


  componentWillLoad() {
    if(this.tk === undefined) {
      this.tk = true;
    }
    if(this.variant != 'title') {
      this.showfootertitle = false;
    }
    if(this.variant === 'chip') {
      this.showProductChip = true;
    }
    if(this.fullscreen) {
      this.showfootertitle = false;
      this.showProductCard = true;
      this.showProductChip = false;
    }

    this.playlist = this.fsplaylist || null;
    this.items = this.playlist?.itemsdata || [];
    if(!this.fsplaylist) {
      for(var i=0; i<10; i++) {
        this.items.push({
          title: '',
          url: null,
          loading: true,
        });
      }
    } else {
      this.loading = false;
    }
  }

  async componentDidLoad() {
    // this.setupLoadingFlkty();
    let rh = window.innerHeight - 40;
    if(window.innerWidth <= 576) {
      rh = window.innerHeight;
    }
    this.rh = (rh > 1024) ? 1024 : rh;

    if(!this.fsplaylist) {
      let cheader = {
        "Content-type": "application/json;charset=UTF-8",
      };

      if(this.channelId) {
        cheader["channel_id"] = this.channelId;
      }
      const playlistResponse = await fetch(`${this.getApiUrl(this.env)}/web/playlists/${this.playlistId}`, {
        method: "GET",
        headers: cheader,
      });
      if(playlistResponse.status === 200) {
        this.playlist = await playlistResponse.json();
        this.items = this.playlist.itemsdata;
        this.loading = false;
      } else {
        return false;
      }
    }

    if(window.location.hash.indexOf('as-reel-item-true') !== -1) {
      this.open = true;
    }

    if(this.items.length >0) {
      this.channelId = this.playlist.channelId;
      if(this.fullscreen) {
        // console.log('videos', this.items);
      }
      if(this.tk) {
        jitsu.set({
          channelid : this.channelId,
          playlistid: this.playlistId,
          env: this.env === '' ? 'live' : this.env,
          appid: 'allstudio',
          accountid: this.playlist.channel?.accountId,
          mode: this.mode,
        });

        //group posthog
        // posthog.group('accountid', `${this.env === 'live' || this.env === '' ? '': `${this.env}_`}${this.playlist.channel?.accountId}`, {
        //   env: this.env,
        //   channelid: this.channelId,
        //   channel: this.playlist.channel?.title,
        // });
      }
    } else {
      return false;
    }


    if(this.items) {
      if(window.location.hash.includes("#as-playlist-item-true")) {
        this.forcemute = true;
      }
      const s = this;
      s.checkSetup(s);

      // window.history.pushState({
      //   fullscreen: false,
      //   firststate: true,
      // }, null, "");
    }
    // final
  }

  render() {
    return (
      <Host>
          <div class={{ reelsWrapper: true, isOpen: this.open, sizemini: (this.size === 'mini') }} >

          {this.loading && (<div id={`as-reels-${this.playlistId}-${this.fullscreen}-loading`} 
            class={this.fullscreen ? 'fs-as-reels-loading': 'as-reels-loading'}>
              { 
                this.items?.map(() => (
                <div class="carousel-cell swiper-slide"  data-hash={`as-reels-video-${this.fullscreen}-${this.playlistId}-${Date.now()*Math.random()}-loading`}>
                 <div class="cards">
          <div class="card_image loading"></div>
          {/* <div class="card_description loading"></div> */}
        </div> 
                </div>
                ))
              }
            </div>)}

{!this.loading && this.items && <div id={`as-reels-${this.playlistId}-${this.fullscreen}-loaded`} 
class="fs-as-reels swiper">
  <div class="swiper-wrapper">
    { 
      this.items?.map((item, index) => (
      <div class="swiper-slide" 
      id={`as-playlist-item-${this.fullscreen}-${this.playlistId}-${item.type}-${item.typeId}`} 
      data-hash={`as-reel-item-${this.fullscreen}-${this.playlistId}-${item.type}-${item.typeId}`}>
        {item.type === 'video' ? (
        <as-player
        index={index}
        // productoverlay={this.el.shadowRoot.querySelector('as-product-overlay')}
        tk={this.tk}
        playlistId={this.playlistId}
        videoId={item.typeId}
        env={this.env}
        autoplay={this.mode === 'autoplay' ? true : false}
        fullscreen={this.fullscreen}
        fvideo={item.data}
        platform={this.platform}
        showheader={this.fullscreen}
        showfootertitle={this.showfootertitle}
        showproductchip={this.showProductChip}
        showproductcard={this.showProductCard}
        forcemute={this.fullscreen ? this.forcemute : null}
        widget={`reels_player${this.fullscreen ? '_fullscreen' : ''}`}
        playclick={false}
        preload={true}
        h={`${this.rh}px`}
        piphandler={(() => {
          this.exit();
        })}
        mutehandler={!this.fullscreen ? false : ((val) => {
          this.forcemute = val;
          // console.log('mute handler', this.forcemute);
          const aplayers: any = this.el?.shadowRoot.querySelectorAll(".fs-as-reels as-player");
          aplayers?.forEach((item) => {
            item?.muted(this.forcemute);
              });
        })}

        ></as-player>
        ) : <div></div>}

  {item.type === 'photo' ? (
        <as-photo-viewer
        index={index}
        // productoverlay={this.el.shadowRoot.querySelector('as-product-overlay')}
        tk={this.tk}
        playlistId={this.playlistId}
        photoId={item.typeId}
        env={this.env}
        fullscreen={this.fullscreen}
        fphoto={item.data}
        platform={this.platform}
        showheader={this.fullscreen}
        showfootertitle={this.showfootertitle}
        showproductchip={this.showProductChip}
        showproductcard={this.showProductCard}
        widget={`reels_photo_viewer${this.fullscreen ? '_fullscreen' : ''}`}
        playclick={false}
        h={`${this.rh}px`}
        piphandler={(() => {
          this.exit();
        })}
        ></as-photo-viewer>
        ) : <div></div>}
          <div class="bgoverlay"></div>
      </div>
      ))
    }

{/* <div class="swiper-overlay"><as-product-overlay trackevent={this.trackEvent} env={this.env}></as-product-overlay></div> */}

  </div>
</div>}

<div class="swiper-button-prev"></div>
  <div class="swiper-button-next"></div>
  <div class="swipeup-animation vert-move">
    <div><i class="gg-chevron-double-up-o"></i></div>
    <p>SWIPE UP</p>
  </div>


          </div> 
        </Host>
    );
  }

  getApiUrl (env?: string): string {
    let apiUrl = `https://apiv2.allstudio.live`;
    if(env === 'dev') {
      apiUrl = `${apiUrl}/dev`
    } else if(env === 'qa') {
      apiUrl = `${apiUrl}/qa`
    } else if(env === 'local') {
      apiUrl = 'http://localhost:4011';
    }
    return apiUrl;
  }

  setup(s = this) {
    // console.log('setting up flkty', this.items, this.fullscreen);
    var selector = '.fs-as-reels';
    var elem: any = s.el?.shadowRoot.querySelector(selector);
    if(elem) {

      try {
          
        const nextEl: any = s.el?.shadowRoot.querySelector(`.swiper-button-next`);
        const prevEl: any = s.el?.shadowRoot.querySelector(`.swiper-button-prev`);
          // const scrollbarElem: any = this.el?.shadowRoot.querySelector(`${selector} .swiper-scrollbar`);
          let settings: any = {
            direction: 'horizontal',
            effect: 'coverflow',
            coverflowEffect: {
                rotate: 0,
                stretch: 240,
                depth: 100,
                modifier: 1,
                scale: 0.8,
                slideShadows : true,
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            autoHeight: true,
            centeredSlides: true,
            allowTouchMove: false,
          };
          if(window.innerWidth <= 576) {
            settings = {
              direction: 'vertical',
              slidersPerView: 1,
            }
          }
          const swiper = new Swiper(elem, {
            // configure Swiper to use modules
            modules: [Navigation, EffectCoverflow],
            loop: false,
            initialSlide: this.startindex,
            // hashNavigation: {
            //   replaceState: true,
            //   watchState: true,
            // },
            navigation: {
              nextEl,
              prevEl,
            },
            ...settings,
            // slideToClickedSlide: true,
            // scrollbar: {
            //   el: scrollbarElem,
            // },
            // slidesPerGroupAuto: true,

            grabCursor: true,
            on: {
              // ready: function () {
              //   // console.log('flk ready', elem, s.autofullscreen, s.fullscreen, s.loading);
              //     s.carouselReady = true;
              // },
              afterInit: function(swiper) {
                // s.changePlayer(swiper.activeIndex);
                if(s.open) {
                  if(!s.fullscreenPlayer || s.curIndex === 0) {
                    const aplayers: any = s.el?.shadowRoot.querySelectorAll('.swiper-slide');
                    // aplayers[s.startindex]?.querySelector('as-player')?.pause();
                    s.fullscreenPlayer = aplayers[swiper.realIndex]?.querySelector('as-player');
                    s.fullscreenPlayer?.muted(true);
                    s.fullscreenPlayer?.play();

                    setTimeout(() => { const anim: any = s.el.shadowRoot.querySelector('.swipeup-animation');
                    anim.style.display='none'; }, 5000);
                  }
                }
              },
              slideChange: async function (swiper) {
                // console.log('change', swiper.activeIndex, s.loading);
                if(!s.loading) {
                  // await s.checkVisibleItems(s, swiper.activeIndex);
                  s.changePlayer(swiper.activeIndex);
                }
              },
              hashChange: function () {
                s.fullscreenPlayer?.pause();
              }
              // transitionStart: function() {
              //   const aplayers: any = s.el?.shadowRoot.querySelectorAll('.swiper-slide as-player');
              //   aplayers.forEach((p) => p.pause());
              //   this.fullscreenPlayer = null;
              // },
              // transitionEnd: function () {
              //   var index = this.realIndex;
              //   if(s.items[index].type === 'video') {
              //     const aplayers: any = s.el?.shadowRoot.querySelectorAll('.swiper-slide as-player');
              //     this.fullscreenPlayer = aplayers[index];
              //     this.fullscreenPlayer?.play();
              //   }
              // }
            }
          });
      s.swiper = swiper;

        } catch(e) {
          setTimeout(() => s.setup(s), 100);
        }

    }
    else {
      setTimeout(() => s.setup(s), 200);
    }
  }

  changePlayer(activeIndex) {
    if(this.fullscreenPlayer) {
      this.fullscreenPlayer?.pause();
      this.fullscreenPlayer = null;
    }

    const aplayers: any = this.el?.shadowRoot.querySelectorAll('.swiper-slide');
    if(this.items[this.curIndex].type === 'video' && this.curIndex !== activeIndex) {
      aplayers[this.curIndex].querySelector('as-player')?.pause();
      aplayers[this.curIndex].querySelector('as-player')?.closeoverlay();
      aplayers[this.curIndex].querySelector('as-photo-viewer')?.closeoverlay();
    }
    if(this.items[activeIndex].type === 'video') {
      this.fullscreenPlayer = aplayers[activeIndex].querySelector('as-player');
      // console.log('playing from change', this.fullscreenPlayer);
      this.fullscreenPlayer?.play(); 
    }
    this.curIndex = activeIndex;
  }

  checkSetup(s) {
    const videonodes = s.el?.shadowRoot.querySelectorAll('.fs-as-reels .swiper-slide');
    if(videonodes?.length === s.items.length){
      s.setup(s);
      const csl: any = 
      s.el.shadowRoot.querySelector('.fs-as-reels');
  ​
      if (csl) {
        this.observer = new IntersectionObserver(async (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                if (this.observer) {
                   this.observer.disconnect();
                }
        
                // const aplayers: any = entry.target.querySelectorAll('.swiper-slide as-player');
                // aplayers.forEach((ap) => {
                //   ap.load();
                // });
        
                const aviewers: any = entry.target.querySelectorAll('.swiper-slide as-photo-viewer');
                aviewers.forEach((av) => {
                  av.load();
                });        
                s.cslready = true;  
              }
            }
          });
        this.observer.observe(csl);
      }

    } else {
      setTimeout(() => s.checkSetup(s), 100);
    }
}

openReels() {
  this.changePlayer(this.swiper.realIndex);
}

closeReels() {
  this.fullscreenPlayer?.pause();
  this.fullscreenPlayer = null;
}

trackEvent(name, data) {
  if(this.tk || this.tk === undefined) {
    // console.log('tracking event', name, data);
    jitsu.set({
      channelid : this.channelId,
      playlistid: this.playlistId,
      env: this.env === '' ? 'live' : this.env,
      appid: 'allstudio',
      accountid: this.playlist.channel?.accountId,
      mode: this.mode,
      category: 'reels'
    });

    // posthog.register_once({
    //   channelid : this.channelId,
    //   playlistid: this.playlistId,
    //   env: this.env === '' ? 'live' : this.env,
    //   appid: 'allstudio',
    //   accountid: this.playlist.channel?.accountId,
    //   mode: this.mode,
    //   category: 'reels'
    // })
    
    try {
      jitsu.track(name, data);
      // posthog.capture(name, data);
    } catch(e) {
      console.log('jitsu tracking error', e);
    }
  }
}

}
